import { useTranslation } from "react-i18next";
import { Navigate, Route, Routes } from "react-router-dom";
import {
  FirstLoginChangePassword,
  FirstLoginForm,
  LoginForm,
  LoginWithRecoveryCodeForm,
} from "./components";
import { SingleCard } from "./layouts";

export const UnauthenticatedContent = () => {
  const { t } = useTranslation();

  return (
    <Routes>
      <Route
        path="/sign-in"
        element={
          <SingleCard title={t("login")}>
            <LoginForm />
          </SingleCard>
        }
      />
      <Route
        path="/recovery-code-login"
        element={
          <SingleCard title={t("recoveryCodeLogin")}>
            <LoginWithRecoveryCodeForm redirectLink="/sign-in" />
          </SingleCard>
        }
      />
      <Route
        path="/first-login"
        element={
          <SingleCard title={t("firstLogin")}>
            <FirstLoginForm redirectLink="/sign-in" />
          </SingleCard>
        }
      />
      <Route
        path="/first-change-password"
        element={
          <SingleCard title={t("firstLoginChangePassword")}>
            <FirstLoginChangePassword redirectLink="/sign-in" />
          </SingleCard>
        }
      />
      <Route path="*" element={<Navigate to="/sign-in" />} />
    </Routes>
  );
};
